import FalconComponentCard from "components/common/FalconComponentCard";
import React from "react";
import { Button, Col, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import AddPractitionerForm from "./AddPractitionerForm";
import { useNavigate, useParams } from "react-router-dom";
import paths from "routes/paths";
import moment from "moment";
import { CreatePractitioner } from "../config/practitionerSliceAPi";
import { toast } from "react-toastify";
import BackButton from "components/common/custom/back-button";

const AddPractitioner = ({ view }) => {
  const dispatch = useDispatch();

  const { allPermissionType } = useSelector((state) => state.role);
  const practitonerSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) => item?.rolemngmttyp_name === "Practitioner"
  );

  const {
    control,
    watch,
    setValue,
    reset,
    handleSubmit,
    formState: { errors, isSubmitted },
  } = useForm({
    defaultValues: {},
  });

  const navigate = useNavigate();

  const { id } = useParams();

  const handleReset = () => {
    reset();
  };

  const handleAddPractitioner = async (data) => {
    const payload = {
      ...(id && { practitioner_id: id }),
      practitioner_license: data?.licence_number || "",
      practitioner_license_exp: data?.license_exp_date
        ? moment(data?.license_exp_date).format("YYYY-MM-DD")
        : "",
      practitioner_title: "",
      practitioner_firstname: data?.first_name_eng || "",
      practitioner_firstname_arabic: data?.first_name_arabic || "",
      practitioner_fathername: "",
      practitioner_fathername_arabic: "",
      practitioner_familyname: data?.last_name_eng || "",
      practitioner_familyname_arabic: data?.last_name_arabic || "",
      practitioner_specialities:
        data?.speciality?.map((item) => item?.label)?.join(",") || "",
      branch_cchi:
        data?.branch
          ?.map((item) => item?.cchi || item?.branch_cchino)
          ?.join(",") || "",
      practitioner_mobilenumber: data?.mobile_no || "",
      practitioner_emailid: data?.email || "",
      practitioner_gender: data?.gender?.label || "",
      practitioner_dob: data?.birth_date
        ? moment(data?.birth_date).format("YYYY-MM-DD")
        : "" || "",
      practitioner_maritalstatus:
        data?.marital_status?.maritalstatus_disply || "",
      practitioner_nationality: data?.nationality?.name || "",
      practitioner_nationalid: data?.national_id,
      practitioner_address: "",
      practitioner_address_arabic: "",
    };

    const response = await dispatch(CreatePractitioner(payload)).unwrap();
    if (response?.success) {
      toast.success(response?.message_en);
      navigate("/practitioner/practitioner-list");
      reset();
    } else {
      toast.error(response?.message_en);
    }
  };

  return (
    <>
      {((id ? Number(practitonerSetting?.edit) === 1 : Number(practitonerSetting?.add) === 1) || (view && Number(practitonerSetting?.view) === 1)) ? (
        <Form
          noValidate
          onSubmit={handleSubmit(handleAddPractitioner)}
          className="p-0"
        >
          <FalconComponentCard
            className="shadow-md"
            style={{ position: "relative" }}
          >
            <FalconComponentCard.Header
              className="d-flex  fixed-header justify-content-between align-items-center"
              sx={{
                position: "sticky !important",
                top: 68,
                zIndex: 1020,
                backgroundColor: "white",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              <BackButton
                path={paths.practitionerList}
                title={`${id ? (view ? "View" : "Update") : "Add"
                  } Practitioner`}
              />

              <Col xs="auto" className="d-flex gap-2">
                {!view && (
                  <>
                    <Button
                      size="sm"
                      variant="outline-danger"
                      onClick={handleReset}
                    >
                      Reset
                    </Button>
                    <Button type="submit" size="sm" variant="success">
                      {id ? "Update" : "Save"}
                    </Button>
                  </>
                )}
              </Col>
            </FalconComponentCard.Header>
            <FalconComponentCard.Body
              style={{
                marginTop: "40px", // Adjust this value based on header height
                overflowY: "auto",
                maxHeight: "calc(100vh - 200px)", // Adjust based on your needs
              }}
            >
              <AddPractitionerForm
                watch={watch}
                setValue={setValue}
                errors={errors}
                control={control}
                isSubmitted={isSubmitted}
                view={view}
              />
            </FalconComponentCard.Body>
          </FalconComponentCard>
        </Form>
      ) : (
        <div className="py-6 text-center border rounded-3mb-3">
          <h5 className="text-danger">Permission Denied</h5>
          <p className="text-muted fs-11">
            You do not have permission to {view ? "view" : (id ? "edit" : "add")} Practitioner.
          </p>
        </div>
      )}
    </>
  );
};

export default AddPractitioner;
